import React from 'react'
import { Tooltip } from "antd";

const HideTalentPricingTooltip = () => {
    return (
        <span className="inline-block">
            <Tooltip
                placement="top"
                // color="#5F3DB1"
                color="#913EF0"
                title={(
                    <p className="text-white italic text-xs">
                        Rates and pricing details are confidential and available only to users with the right privileges.
                    </p>
                )}
            >
                <p className="cursor-default flex text-inherit">Confidential <i className="fa fa-info-circle text-xs ml-1" /></p>
            </Tooltip>
        </span>
    )
}

export default HideTalentPricingTooltip;